import { render, staticRenderFns } from "./groupMessage.vue?vue&type=template&id=9680220c&scoped=true&"
import script from "./groupMessage.vue?vue&type=script&lang=js&"
export * from "./groupMessage.vue?vue&type=script&lang=js&"
import style0 from "./groupMessage.vue?vue&type=style&index=0&id=9680220c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9680220c",
  null
  
)

export default component.exports